import { combineReducers } from "@reduxjs/toolkit";
import rootSlice from "../reducers/root.slice";
import rightPanel2Slice from "../reducers/rightPanel2.slice";
import workerSlice from "../reducers/worker.slice";

const rootReducer = combineReducers({
  [rootSlice.name]: rootSlice.reducer,
  [rightPanel2Slice.name]: rightPanel2Slice.reducer,
  [workerSlice.name]: workerSlice.reducer,
});

export default rootReducer;
